module.exports = __webpack_public_path__ + "img/tour_guide.48076238.jpg";